const lang = {
  menu: {
    group_business: '業務',
    group_management: '管理',
    customer_information: '顧客情報管理',
    addon_property_management: '添付物管理',
    email_fixed_management: 'メール定型文管理',
    support_industry_management: '提携業者管理',
    my_profile: 'マイプロフィール',
  },
  btn_back: '一つ前に戻る',
}

export default lang
